import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLsjl = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 48 48" {...props}>
    <path
      d="M8.685 39.329V7.846h5.247v.875a1.749 1.749 0 1 0 3.5 0v-.875H21.8v.875a1.749 1.749 0 1 0 3.5 0v-.875h4.373v.875a1.749 1.749 0 0 0 3.5 0v-.875h5.247v31.483H8.685Zm3.5-7.654a1.532 1.532 0 0 0 1.533 1.532h10.051a1.532 1.532 0 0 0 1.531-1.532v-.433a1.532 1.532 0 0 0-1.532-1.533H13.716a1.532 1.532 0 0 0-1.533 1.533v.433Zm22.736-14.426a1.532 1.532 0 0 0-1.533-1.532H13.716a1.532 1.532 0 0 0-1.533 1.532v.433a1.532 1.532 0 0 0 1.533 1.532h19.672a1.532 1.532 0 0 0 1.533-1.532v-.433Zm0 7a1.532 1.532 0 0 0-1.533-1.532H13.716a1.532 1.532 0 0 0-1.533 1.532v.433a1.532 1.532 0 0 0 1.533 1.532h19.672a1.532 1.532 0 0 0 1.533-1.532v-.436Z"
      style={{
        fill: 'currentColor',
				fillRule: 'evenodd',
      }}
    />
  </svg>
);
export default SvgLsjl;
